module.exports = __webpack_public_path__ + "static/img/sirim-blue.03e74a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sirim-blue.jpg
// module id = 3/TG
// module chunks = 73